import UseCaseTemplate, { type UseCaseContent } from '../../components/UseCaseTemplate';

const content: UseCaseContent = {
  slug: 'commercial-parking-operator',
  title: 'Commercial Parking Operators — List Your Lots on Parksy | Parksy',
  description:
    "Commercial parking operators: list your lot on Parksy.rent for free. Reach seekers actively searching in your area. No commission, no subscription, just leads.",
  canonicalPath: '/commercial-parking-operator',
  ogImage: 'https://parksy.rent/og/commercial-parking-operator.png',
  heroIntro:
    "Parksy is for commercial operators too — list your multi-bay lot, set vehicle types and access rules, and we'll match you with verified seekers within 3 km. Free forever; no commission on bookings; you handle payments directly with the customer.",
  painPoints: [
    'Aggregator platforms take 15–25% of every booking.',
    'Lead-gen platforms charge per inquiry, regardless of conversion.',
    'You can\'t reach park-and-ride commuters without an expensive Google Ads budget.',
    'Customer reviews on Google Maps are hard to control.',
  ],
  solutions: [
    { title: 'Free listing, no commission', body: "List unlimited spots at no cost. When matched, you receive the seeker's contact directly — no platform in the middle, no commission on the booking." },
    { title: 'Self-managed availability', body: "Set your own hours, vehicle types, security features, and rates. Renew your listing every 90 days (one click)." },
    { title: 'Reach new demand', body: "Parksy surfaces your spot to seekers actively searching within 3 km — including the metro-adjacent and airport-adjacent commuter traffic most operators miss." },
  ],
  citySpotlights: [
    { slug: 'mumbai', name: 'Mumbai', note: 'High-density lot demand' },
    { slug: 'delhi', name: 'Delhi', note: 'Multi-bay operators' },
    { slug: 'bangalore', name: 'Bangalore', note: 'Tech-park shuttles' },
    { slug: 'hyderabad', name: 'Hyderabad', note: 'New HITEC demand' },
    { slug: 'pune', name: 'Pune', note: 'Hinjewadi IT parks' },
    { slug: 'kolkata', name: 'Kolkata', note: 'Salt Lake Sector V' },
  ],
  faqs: [
    { question: 'Does Parksy charge a commission?', answer: "No. Parksy is free for both seekers and listers. We cover server costs through non-intrusive ads, similar to how Wikipedia operates." },
    { question: 'Can I manage multiple lots from one account?', answer: "Parksy doesn't have user accounts — each listing is identified by your IP hash, so you can list as many spots as you want from one device, and edit/delete them as needed." },
    { question: 'How do I receive bookings?', answer: "When matched, you receive an email with the seeker's contact. You confirm availability and handle payment directly — Parksy is not a payment processor." },
    { question: 'What if a seeker no-shows?', answer: "Parksy is a discovery and matching platform only. We don't process payments or hold funds, so no-show risk is between you and the seeker. Use ratings to flag bad actors." },
  ],
  primaryCta: { label: 'List your commercial lot →', to: '/list-your-parking' },
  secondaryCta: { label: 'See price benchmarks', to: '/stats' },
  breadcrumbs: [
    { label: 'Home', to: '/' },
    { label: 'Commercial operators' },
  ],
};

export default function CommercialParkingOperator() {
  return <UseCaseTemplate content={content} />;
}

